// Consolidated Email hub — Templates / Activity / Automations in one menu item (Trent, Nov 2026).
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth";
import EmailTemplates from "./EmailTemplates";
import EmailLog from "./EmailLog";
import EmailAutomations from "./EmailAutomations";

export default function EmailCenter() {
  const [sp, setSp] = useSearchParams();
  const { user } = useAuth();
  const isAdmin = ["admin", "super_admin"].includes(user?.role);
  const rawTab = sp.get("tab") || "templates";
  const tab = !isAdmin && rawTab === "automations" ? "templates" : rawTab;
  return (
    <div data-testid="email-center">
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v }, { replace: true })}>
        <TabsList className="rounded-sm mb-4">
          <TabsTrigger value="templates" className="rounded-sm" data-testid="email-tab-templates">Templates</TabsTrigger>
          <TabsTrigger value="activity" className="rounded-sm" data-testid="email-tab-activity">Activity</TabsTrigger>
          {isAdmin && <TabsTrigger value="automations" className="rounded-sm" data-testid="email-tab-automations">Automations</TabsTrigger>}
        </TabsList>
        <TabsContent value="templates"><EmailTemplates /></TabsContent>
        <TabsContent value="activity"><EmailLog /></TabsContent>
        {isAdmin && <TabsContent value="automations"><EmailAutomations /></TabsContent>}
      </Tabs>
    </div>
  );
}
